import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer
      className="bg-[#0B2545] text-[#F9F8F6] py-16 sm:py-20"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid sm:grid-cols-12 gap-10">
          <div className="sm:col-span-5">
            <div className="flex items-center gap-2 mb-5">
              <span className="h-2.5 w-2.5 rounded-full bg-[#B4C5A4]" />
              <span className="font-sans-display font-semibold tracking-tight text-lg">
                AI METABOLIC
              </span>
            </div>
            <p className="text-[#F9F8F6]/70 max-w-md leading-relaxed">
              {t("footer.description")}
            </p>
          </div>

          <div className="sm:col-span-3">
            <p className="text-xs uppercase tracking-[0.18em] text-[#B4C5A4] font-sans-display mb-4">
              {t("footer.projectTitle")}
            </p>
            <ul className="space-y-2 text-sm text-[#F9F8F6]/80">
              <li><a className="underline-grow" href="/#problem">{t("nav.problem")}</a></li>
              <li><a className="underline-grow" href="/#daily-ai">{t("nav.daily")}</a></li>
              <li><a className="underline-grow" href="/#building">{t("nav.method")}</a></li>
              <li><a className="underline-grow" href="/#wins">{t("nav.wins")}</a></li>
              <li>
                <Link to="/blog" className="underline-grow" data-testid="footer-blog-link">
                  {t("nav.blog")}
                </Link>
              </li>
            </ul>
          </div>

          <div className="sm:col-span-2">
            <p className="text-xs uppercase tracking-[0.18em] text-[#B4C5A4] font-sans-display mb-4">
              {t("footer.legalTitle")}
            </p>
            <ul className="space-y-2 text-sm text-[#F9F8F6]/80">
              <li>
                <Link
                  to="/avis-legal"
                  className="underline-grow"
                  data-testid="footer-legal-notice-link"
                >
                  {t("footer.legalNotice")}
                </Link>
              </li>
              <li>
                <Link
                  to="/politica-privacitat"
                  className="underline-grow"
                  data-testid="footer-privacy-link"
                >
                  {t("footer.privacyPolicy")}
                </Link>
              </li>
              <li>
                <Link
                  to="/politica-cookies"
                  className="underline-grow"
                  data-testid="footer-cookies-link"
                >
                  {t("footer.cookiePolicy")}
                </Link>
              </li>
            </ul>
          </div>

          <div className="sm:col-span-2">
            <p className="text-xs uppercase tracking-[0.18em] text-[#B4C5A4] font-sans-display mb-4">
              {t("footer.contactTitle")}
            </p>
            <ul className="space-y-2 text-sm text-[#F9F8F6]/80">
              <li>hola@ai-metabolic.com</li>
              <li>{t("footer.contactCity")}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#F9F8F6]/15 flex flex-col gap-6">
          <p
            className="text-xs text-[#F9F8F6]/55 leading-relaxed max-w-3xl"
            data-testid="footer-disclaimer"
          >
            {t("footer.disclaimer")}
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 pt-4 border-t border-[#F9F8F6]/10">
            <p className="text-xs text-[#F9F8F6]/50">
              © {new Date().getFullYear()} AI METABOLIC. {t("footer.copyright")}
            </p>
            <p className="text-xs text-[#F9F8F6]/50">{t("footer.medical")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
